export default __webpack_public_path__ + "static/media/no-image.ce4a0886.png";